import { useEffect, useState } from 'react';

/** El valor, pero recién cuando deja de cambiar por `ms` milisegundos (para buscar mientras se escribe). */
export function useDebounced<T>(value: T, ms = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return debounced;
}
